import { Caract_sol } from '../../../models/caract_sol.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment'
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: "page-caract_sol",
    templateUrl: "./caract_sol.component.html",
    styleUrls: ["./caract_sol.component.css"],
    providers: [FormService]
})

export class Caract_solComponent {
      public rows = [];
      public actualRow;
      public caract_sol: Caract_sol;
      public form;
      public matcher = new FormService();
      public formNumber;
      public encontrado;
      public tipo_garantia = {"GARANTÍA PARCIAL": false, "GARANTÍA TOTAL": false, "VIALIDAD":false, "PARQUE":false}
    public fecha;
    public maxDate;
    constructor() {

        this.encontrado = JSON.parse(localStorage.getItem("form"));


        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            num_reso_perm: new FormControl(''),
            fecha_reso_perm: new FormControl({ value: '', disabled: true })
        })

        if (!JSON.parse(localStorage.getItem("caract_sol"))) {
            localStorage.setItem("caract_sol", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("caract_sol"));
            this.form.controls['num_reso_perm'].setValue(this.rows[0] ? this.rows[0].num_reso_perm : '');
            this.form.controls['fecha_reso_perm'].setValue(this.rows[0] ? this.rows[0].fecha_reso_perm : null);
            this.tipo_garantia = {
                "GARANTÍA PARCIAL": this.rows[0] ? this.rows[0].tipo_garantia['GARANTÍA PARCIAL'] : false,
                "GARANTÍA TOTAL": this.rows[0] ? this.rows[0].tipo_garantia['GARANTÍA TOTAL'] : false,
                "VIALIDAD": this.rows[0] ? this.rows[0].tipo_garantia['VIALIDAD'] : false,
                "PARQUE": this.rows[0] ? this.rows[0].tipo_garantia['PARQUE'] : false
            }
        }
         this.caract_sol = {num_reso_perm:'',fecha_reso_perm:null, tipo_garantia:''};

    }

    add_caract_sol(event?: MatDatepickerInputEvent<Date>, type?) {
        
        if (event) {

            this.fecha = moment(event.value).format('DD/MM/YYYY')
        }
        else {
            var temp = JSON.parse(localStorage.getItem("caract_sol"))
            if (temp > 0) {
                this.fecha = temp[0].fecha_reso_perm;

            }
        }

        localStorage.setItem("caract_sol", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_sol");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            num_reso_perm: this.form.value.num_reso_perm,
            tipo_garantia: this.tipo_garantia,
            fecha_reso_perm: this.fecha
        })
        localStorage.setItem("caract_sol", JSON.stringify(this.rows));

    }

    delete_caract_sol(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_sol", JSON.stringify(this.rows));
            }
        }
    }

}